import { SupportedLocales } from '@datachain/ui-sdk/common';

import { Datachain } from '../constants';

export const getLocale = (): string => {
	const saved = localStorage.getItem(Datachain.CachedLang);
	return saved === null || saved === undefined
		? SupportedLocales.Fr
		: parseLang(saved);
};

const parseLang = (langKey: string): string => {
	switch (langKey) {
		case 'en':
			return SupportedLocales.En;
		case 'fr':
			return SupportedLocales.Fr;
		case 'browser': {
			const lang: string =
				navigator.language || (navigator as any).userLanguage;

			if (lang === 'fr-FR' || lang === 'fr') {
				return SupportedLocales.Fr;
			}
			if (lang === 'en-US' || lang === 'en') {
				return SupportedLocales.En;
			}
			break;
		}
	}
	return SupportedLocales.Fr;
};
